<template>
  <v-dialog v-model="dialog" persistent width="600">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline ">
        <v-flex xs9>
          <v-icon>edit</v-icon> Modificar fechas del horario de la persona
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md style="min-width: 100%" class="py-0 px-3">
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="form.fecha_desde"
                  :rules="$validate(['required'])"
                  required
                  label="Fecha de inicio"
                  type="date"
                  outline
                  clearable
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="form.fecha_hasta"
                  :rules="$validate(['required'])"
                  required
                  label="Fecha fin"
                  type="date"
                  outline
                  clearable
                >
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      horarios: [],
      persona: {},
      user: this.$storage.get("user")
    };
  },
  watch: {},
  mounted() {
    this.obtenerHorarios();
    this.$bus.$on("openDialogEditarHorarioGeneral", item => {
      this.form = item;
      console.log('item.....',item);
      this.dialog = true;
    });
  },
  methods: {
    async obtenerHorarios() {
      console.log('obtenerHorario....');
      try {
        let res = await this.$service.graphql({
          query: `
						query{
							horarios{
								rows{
									id
									descripcion
                  hora_inicio
                  hora_fin
								}
							}
						}
					`
        });
        this.horarios = res.horarios.rows;
        console.log('this.horarios.....', this.horarios);
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.form = {};
      this.loading = false;
      this.persona = [];
      this.valid = false;
      this.$bus.$emit("closeDialog2");
      this.dialog = false;
    },
    async save() {
      if (this.$refs.form.validate()) {
        console.log('save');
        try {
          this.loading = true;
          let query = `select control.fn_modifica_fechas_horario_persona(${this.form.id_persona},${this.form.id_horario_persona},'${this.form.fecha_desde}','${this.form.fecha_hasta}',${this.user.id})`;
          let res = await this.$service.graphql({
            query: `query{
              runQuery(consulta:"${query}"){
                  respuesta
                }
              }
            `
          });
          let rpta = res.runQuery.respuesta[0].fn_modifica_fechas_horario_persona.split(
            "|"
          );
          if (rpta[0] == "1") {
            this.$bus.$emit("closeDialog");
            this.$message.success();
            this.close();
          } else {
            this.$message.info(rpta[1]);
          }
          this.loading = false;
        } catch (error) {
          console.log(error);
        }
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/asignacion_horario/dialogs/EditarHorarioGeneral.vue